import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import MainPage from "./MainPage";
import { TABLET_WIDTH } from "../constant";
import useWindowDimensions from "../hooks/useWindowDimension";
import CookiesNotification from "../shared/CookiesNotification";
import { cn } from '@chapche/ui';

/** Draw editor routes: collapse chrome so canvas gets width (ADR shell). */
export const isSvgLibraryEditorPath = (pathname) => {
    if (pathname === '/svg-library/new' || pathname === '/svg-library/new/') {
        return true;
    }
    return /^\/svg-library\/[^/]+\/edit\/?$/.test(pathname);
};

const WithWrapper = () => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [menuCollapsed, setMenuCollapsed] = useState(false);
    const { width } = useWindowDimensions();
    const { pathname } = useLocation();
    const isEditor = isSvgLibraryEditorPath(pathname);

    useEffect(() => {
        setMenuCollapsed(isEditor);
    }, [isEditor]);

    return (
        <>
            {width <= TABLET_WIDTH ? <Header setMenuIsOpen={setMenuIsOpen} menuIsOpen={menuIsOpen}/> : null}
            <CookiesNotification />
            <main className={cn('main box-border flex min-h-screen w-full flex-nowrap items-stretch', menuCollapsed && width > TABLET_WIDTH && 'main_menu-collapsed')}>
                {(width <= TABLET_WIDTH && menuIsOpen) || width > TABLET_WIDTH ?
                    <MainPage
                        menuIsOpen={menuIsOpen}
                        setMenuIsOpen={setMenuIsOpen}
                        menuCollapsed={menuCollapsed && width > TABLET_WIDTH}
                        setMenuCollapsed={setMenuCollapsed}
                    />
                    :
                    null}
                <Outlet />
            </main>
        </>
    );
};

export default WithWrapper;
